module.exports = __webpack_public_path__ + "img/Cart-Minus.1b6626ba.svg";